import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { useQueryParams } from '@upright/ui/common/generic/hooks/url-handling/query-params';
import { allImpactLenses } from '@upright/ui/common/upright/core/impact-lenses/types';

/**
 * This hook is used to get and set the lens through URL search params.
 */
export function useGetLensAndSetter(): {
  lens: ImpactLensType;
  setLens: (lens: ImpactLensType) => void;
} {
  const [queryParams, setQueryParams] = useQueryParams<{ lens: string }>(['lens']);
  const lensParam = validateLensParam(queryParams.lens);

  return {
    lens: lensParam || ImpactLensType.UPRIGHT_NET_IMPACT,
    setLens: (newLens: ImpactLensType) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setQueryParams({ lens: newLens });
    },
  };
}

function validateLensParam(param: string | undefined): ImpactLensType | undefined {
  if (!param || !isLens(param)) {
    return undefined;
  }
  return param;
}

function isLens(input: string): input is ImpactLensType {
  return allImpactLenses.includes(input as ImpactLensType);
}

export type LensSetter = ReturnType<typeof useGetLensAndSetter>['setLens'];
